import React from 'react';
import { Box, Image } from '@common-fe/common-fe';

import verificationBanner from '@/assets/placeholders/verify/verificationBanner.svg';
import { whiteLabelingConfig } from '@/utils/whiteLabeling';

const VerificationBackground = () => (
  <Box fill direction="column" align="stretch" justify="between">
    <Box fill></Box>
    {/* <Image src={coloudsImage} /> */}
    <Box>
      <Image
        src={
          (whiteLabelingConfig?.images?.verificationBackground as string) || (verificationBanner as string)
        }
        fill="horizontal"
        fit="contain"
      />
    </Box>
  </Box>
);

export default VerificationBackground;
